import { toaster } from "@/components/ui/toaster";
import { AxiosError } from "axios";
import { Dispatch, SetStateAction } from "react";
import { NavigateFunction } from "react-router-dom";
import {
  getExternalTransferRequest,
  getExternalTransferRequests,
} from "@/services/external-transfer.service";
import { handlePermissionError } from "@/utils/permission-check";
import {
  ExternalTransferDetail,
  ExternalTransferListResponse,
} from "./external-transfer.schema";

interface FetchExternalTransferRequestsHandlerProps {
  filters?: any;
  showLoad?: boolean;
  setLoadingExternalTransfers: Dispatch<SetStateAction<boolean>>;
  setExternalTransfers: Dispatch<SetStateAction<ExternalTransferListResponse>>;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const fetchExternalTransferRequestsHandler = async ({
  filters,
  showLoad = true,
  setLoadingExternalTransfers,
  setExternalTransfers,
  navigate,
  fetchPermissions,
}: FetchExternalTransferRequestsHandlerProps) => {
  try {
    if (showLoad) setLoadingExternalTransfers(true);

    const response = await getExternalTransferRequests({
      ...filters,
      "P.Pagina": filters?.["P.Pagina"] ?? 1,
      "P.Records": 10,
    });

    setExternalTransfers(
      (response ?? {
        listado: [],
        totalPages: 1,
        totalRecords: 0,
        pendingRequests: false,
      }) as ExternalTransferListResponse,
    );

    setLoadingExternalTransfers(false);
  } catch (error) {
    const errorObj = error as AxiosError<{ message: string }>;
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title:
          errorObj?.response?.data?.message ??
          "No se pudo cargar la lista de transferencias externas.",
      });
    }

    throw error;
  }
};

interface FetchExternalTransferDetailHandlerProps {
  id?: string;
  showLoad?: boolean;
  setLoadingRequest: Dispatch<SetStateAction<boolean>>;
  setRequest: Dispatch<SetStateAction<ExternalTransferDetail | null>>;
  navigate: NavigateFunction;
  fetchPermissions: () => Promise<void>;
}

export const fetchExternalTransferDetailHandler = async ({
  id,
  showLoad = true,
  setLoadingRequest,
  setRequest,
  navigate,
  fetchPermissions,
}: FetchExternalTransferDetailHandlerProps) => {
  try {
    if (showLoad) setLoadingRequest(true);

    const response = await getExternalTransferRequest(Number(id));

    setRequest(response);
    setLoadingRequest(false);
  } catch (error) {
    const errorObj = error as AxiosError<{ message: string }>;
    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title:
          errorObj?.response?.data?.message ??
          "No se pudo cargar el detalle de la transferencia externa.",
      });
    }

    throw error;
  }
};
